export default "__VITE_ASSET__aIR26NGP__"